<template>
  <div
    class="wrapper relative self-center flex text-gray-500 text-xs md:text-sm"
  >
    <div>
      <select
        v-model="selectedOrderBy"
        class="bg-[transparent] self-center pl-1 pr-2 cursor-pointer appearance-none focus:outline-none"
        @update:model-value="onChange"
      >
        <option
          v-for="opt in orderByOptions"
          :key="opt.slug"
          :value="opt.slug"
          :selected="opt.slug === $route.query.orderBy"
          class="text-right"
        >
          {{ opt.label }}
        </option>
      </select>
    </div>
    <IconSortAlphabetical class="mt-0.5" />
  </div>
</template>

<script lang="ts" setup>
import IconSortAlphabetical from '~/components/icons/IconSortAlphabetical'
const router = useRouter()
const { orderByOptions, currentOrderBy } = useLocalizedOrderBy()
const emit = defineEmits(['updated'])
const selectedOrderBy = ref(currentOrderBy.value?.slug)

async function onChange(val: string) {
  await router.push({
    query: {
      ...router.currentRoute.value.query,
      orderBy: val,
    },
  })
  emit('updated')
}
</script>

<style scoped>
/* .wrapper:after {
  content: ' ';
  position: absolute;
  top: 50%;
  right: 0px;
  width: 0;
  height: 0;
  border-left: 3px solid transparent;
  border-right: 3px solid transparent;
  border-top: 3px solid gray;
} */
</style>
